import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import classes from "./PrivacySupplement.module.css";
import privacyPortuguese from "../utils/languages/privacy/portuguese.privacy.json";
import privacyEnglish from "../utils/languages/privacy/english.privacy.json";
import privacyFrench from "../utils/languages/privacy/french.privacy.json";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../store/slices/languageSlice";
import { languages } from "../utils/constants";
import { FaArrowLeft } from "react-icons/fa6";

const languageMap = new Map([
    [1, privacyEnglish],
    [2, privacyFrench],
    [3, privacyPortuguese]
]);

const Privacy = () => {
    const { t, i18n } = useTranslation();

     const [privacyData, setPrivacyData] = useState(null);
        const [data,setData]=useState(null);

    const dispatch = useDispatch();
    const navigate=useNavigate();

    const selectedLanguageId = Number(
        useSelector((state) => state?.persisted?.languageSlice?.language ?? 1)
    );

      useEffect(() => {
          const mapped = languageMap.get(selectedLanguageId) || languageMap.get("1");
          setPrivacyData(mapped);
          setData(mapped?.privacySupplement || {});
      }, [selectedLanguageId]);

    const handleLanguageChange = (e) => {
        const langId = Number(e.target.value);
        dispatch(setLanguage(langId));
        i18n.changeLanguage(String(langId));
    };

    if (!privacyData) return null;

    return (
        <div className={classes.page}>
            <div className={classes.container}>
                <div className={classes.topBar_back_btn}>
                    <button className={classes.back_btn} onClick={()=>navigate(-1)}>
                        <FaArrowLeft className={classes.back_icon} />
                    </button>
                    <div className={classes.lang}>
                        <span>🌐</span>

                        <select
                            className={classes.langSelect}
                            value={selectedLanguageId}
                            onChange={handleLanguageChange}
                        >
                            {languages.map((lang) => (
                                <option key={lang.language_id} value={lang.language_id}>
                                    {lang.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                   <h1 className={classes.title}>
                    {data?.title || `${t("123")} ${t("124")}`}
                </h1>

                <div className={classes.contentBox}>
                    <p>{data?.intro?.[0]}</p>
                    <p>{data?.intro?.[1]}</p>
                    <p>{data?.intro?.[2]}</p>
                    <p>{data?.intro?.[3]}</p>
                    <p>{data?.intro?.[4]}</p>
                    <p>{data?.intro?.[5]}</p>

                    <h3>
                        {data?.sections?.[0]?.id}. {data?.sections?.[0]?.heading}
                    </h3>
                    <p>{data?.sections?.[0]?.content?.[0]}</p>
                    <p>• {data?.sections?.[0]?.items?.[0]}</p>
                    <p>• {data?.sections?.[0]?.items?.[1]}</p>
                    <p>• {data?.sections?.[0]?.items?.[2]}</p>
                    <p>• {data?.sections?.[0]?.items?.[3]}</p>
                    <p>• {data?.sections?.[0]?.items?.[4]}</p>
                    <p>• {data?.sections?.[0]?.items?.[5]}</p>

                    <h3>
                        {data?.sections?.[1]?.id}. {data?.sections?.[1]?.heading}
                    </h3>
                    <p>{data?.sections?.[1]?.content?.[0]}</p>
                    <p>{data?.sections?.[1]?.content?.[1]}</p>
                    <p>{data?.sections?.[1]?.content?.[2]}</p>
                    <p>{data?.sections?.[1]?.content?.[3]}</p>
                    <p>{data?.sections?.[1]?.content?.[4]}</p>
                    <p>{data?.sections?.[1]?.content?.[5]}</p>
                    <p>{data?.sections?.[1]?.content?.[6]}</p>
                    <p>{data?.sections?.[1]?.content?.[7]}</p>
                    <p>{data?.sections?.[1]?.content?.[8]}</p>
                    <p>{data?.sections?.[1]?.content?.[9]}</p>
                    <p>{data?.sections?.[1]?.content?.[10]}</p>

                    <h3>
                        {data?.sections?.[2]?.id}. {data?.sections?.[2]?.heading}
                    </h3>
                    <p>{data?.sections?.[2]?.content?.[0]}</p>
                    <p>• {data?.sections?.[2]?.items?.[0]}</p>
                    <p>• {data?.sections?.[2]?.items?.[1]}</p>
                    <p>• {data?.sections?.[2]?.items?.[2]}</p>
                    <p>• {data?.sections?.[2]?.items?.[3]}</p>
                    <p>• {data?.sections?.[2]?.items?.[4]}</p>
                    <p>• {data?.sections?.[2]?.items?.[5]}</p>
                    <p>{data?.sections?.[2]?.footer?.[0]}</p>
                    <p>{data?.sections?.[2]?.footer?.[1]}</p>

                    <h3>
                        {data?.sections?.[3]?.id}. {data?.sections?.[3]?.heading}
                    </h3>
                    <p>{data?.sections?.[3]?.content?.[0]}</p>
                    <p>{data?.sections?.[3]?.content?.[1]}</p>
                    <p>{data?.sections?.[3]?.content?.[2]}</p>
                    <p>{data?.sections?.[3]?.content?.[3]}</p>
                    <p>{data?.sections?.[3]?.content?.[4]}</p>
                    <p>{data?.sections?.[3]?.content?.[5]}</p>
                    <p>{data?.sections?.[3]?.content?.[6]}</p>

                    <h3>
                        {data?.sections?.[4]?.id}. {data?.sections?.[4]?.heading}
                    </h3>
                    <p>{data?.sections?.[4]?.content?.[0]}</p>
                    <p>{data?.sections?.[4]?.content?.[1]}</p>
                    <p>{data?.sections?.[4]?.content?.[2]}</p>
                    <p>{data?.sections?.[4]?.content?.[3]}</p>

                    <h3>
                        {data?.sections?.[5]?.id}. {data?.sections?.[5]?.heading}
                    </h3>
                    <p>{data?.sections?.[5]?.content?.[0]}</p>
                    <p>{data?.sections?.[5]?.content?.[1]}</p>
                    <p>{data?.sections?.[5]?.content?.[2]}</p>
                    <p>{data?.sections?.[5]?.content?.[3]}</p>
                    <p>{data?.sections?.[5]?.content?.[4]}</p>
                </div>

            </div>
        </div>
    );
};

export default Privacy;